module.exports = "https://static.zego.com/_next/static/images/partner1-fe5eea670875e5d9c79414d9c6655412.png";